module.exports = __webpack_require__.p + "2c78ca9531b7609448016d6303a7bce4.jpg";